import React, { useState, useRef, useMemo } from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { yearInMilliseconds } from "@vmosolutions/oc-interfaces";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ClickAwayListener } from "@mui/material";
import moment from "moment-timezone";

export interface ICalendarIconFieldProps {
  value?: moment.Moment;
  onChange?: (value: moment.Moment, context: any) => any;
  disabled?: boolean;
  minDate?: moment.Moment;
  maxDate?: moment.Moment;
  offset: { x: number; y: number };
}

export const CalendarIconField = (props: ICalendarIconFieldProps): JSX.Element => {
  const {
    value,
    onChange,
    disabled,
    offset = { x: 0, y: 0 },
    minDate = new Date()?.valueOf() - 1 * yearInMilliseconds,
    maxDate = new Date()?.valueOf() + 1 * yearInMilliseconds,
  } = props;

  const buttonRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const popperTransform: string = useMemo(() => {
    // @ts-ignore
    const bounds = buttonRef?.current?.getBoundingClientRect();
    const x = bounds?.left ?? 0;
    const y = bounds?.top ?? 0;
    return `translate(${x + offset?.x}px, ${y + offset?.y}px) !important`;
  }, [isOpen]);

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div ref={buttonRef}>
        <CalendarTodayIcon
          color={disabled ? "disabled" : "inherit"}
          fontSize="small"
          sx={{
            width: "15px",
            height: "15px",
            cursor: "pointer",
            color: "gray",
            marginTop: "4px",
            marginLeft: "2px",
          }}
          onClick={() => {
            if (!disabled) setIsOpen(isOpen ? false : true);
          }}
        />
        <DatePicker
          open={isOpen}
          value={value}
          onChange={(val, context) => {
            onChange(val as moment.Moment, context);
            setIsOpen(false);
          }}
          minDate={minDate}
          maxDate={maxDate}
          slotProps={{
            actionBar: {
              onClick: () => setIsOpen(false),
              actions: ["cancel"],
            },
            popper: {
              sx: {
                transform: `${popperTransform}`,
              },
            },
            textField: {
              sx: {
                display: "none",
              },
            },
          }}
        />
      </div>
    </ClickAwayListener>
  );
};
